import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import { PageWrapper } from '../components/layout/PageWrapper'
import { Seo } from '../components/Seo'
import { HELP_ARTICLES } from '../lib/helpArticles'

export function HelpIndex() {
  return (
    <PageWrapper>
      <Seo
        title="Plumbing Help & Emergency Advice"
        description="Practical guides for common plumbing emergencies — burst pipes, boiler breakdowns, no hot water, blocked drains and more, plus what an emergency plumber costs."
        path="/help"
        breadcrumbs={[{ name: 'Help', url: '/help' }]}
      />

      <div className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-extrabold text-gray-900 mb-2">Plumbing help &amp; emergency advice</h1>
        <p className="text-gray-500 mb-10">What to do in a plumbing emergency — and how to get a qualified plumber fast.</p>

        <div className="space-y-3">
          {HELP_ARTICLES.map(a => (
            <Link
              key={a.slug}
              to={`/help/${a.slug}`}
              className="group flex items-center justify-between gap-4 bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md hover:border-gray-200 transition-all p-5"
            >
              <div>
                <p className="font-semibold text-gray-900">{a.title}</p>
                <p className="text-sm text-gray-500 mt-1">{a.metaDescription}</p>
              </div>
              <ChevronRight className="h-5 w-5 text-gray-300 group-hover:text-trust-400 transition-colors flex-shrink-0" />
            </Link>
          ))}
        </div>
      </div>
    </PageWrapper>
  )
}
